<template>
    <div class="timeline-modal-info-item" :class="[getTheme, productClass]">
        <div class="timeline-modal-info-item__header">
            <div class="timeline-modal-info-item__item timeline-modal-info-item__icon" v-if="$slots.icon || icon">
                <slot class="timeline-modal-info-item__icon" name="icon" v-if="$slots.icon"></slot>
                <SvgIcon class="timeline-modal-info-item__icon icon img-icon" :name="icon" v-else/>
            </div>
            <div class="timeline-modal-info-item__item timeline-modal-info-item__text">
                {{ address }}
            </div>
        </div>
        <div class="timeline-modal-info-item__info">
            <div class="timeline-modal-info-item__info-item" v-if="event?.time?.formated?.datetime">
                {{ $t('Shipment.Date and time') }}: {{ event?.time?.formated?.datetime }}
            </div>
            <div class="timeline-modal-info-item__info-item" v-if="event?.time_start?.formated?.datetime">
                {{ $t('Shipment.Shipment Start Date and Time') }}: {{ event?.time_start?.formated?.datetime }}
            </div>
            <div class="timeline-modal-info-item__info-item" v-if="event?.time_end?.formated?.datetime">
                {{ $t('Shipment.ETA Date and Time') }}: {{ event?.time_end?.formated?.datetime }}
            </div>
            <div class="timeline-modal-info-item__info-item timeline-modal-info-item__info-item--warn">
                <span>{{ event.text }}</span>

            </div>
            <template v-for="(value, sensor) in sensors" :key="sensor">
                <div class="timeline-modal-info-item__info-item"
                     v-if="value?.value != null"
                >
                    <span>{{ $t('Unit.sensors.' + sensor) }}:</span>
                    <span>{{ value?.text }}</span>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "ShipmentTimelineModalInfo",
    props: {
        event: [Object],
    },
    computed: {
        ...mapGetters([
            "getTheme",
        ]),
        productClass() {
            return this.$product+'-'+this.$site
        },
        address() {
            // (this.event?.latlng?.length ? `lat: ${this.event?.latlng[0]} lng: ${this.event?.latlng[1]}`)
            return this.event?.address || this.$t('text.No Coordinates');
        },
        icon() {
            return this.event?.icon
        },
        sensors() {
            return this.event?.sensors//?.filter(s => s.value || s.value == 0) || []
        },
        trigger() {
            return this?.event?.trigger
        },
        triggerType() {
            return this.event?.triggerType?.toLowerCase()
        }
    }
}
</script>

<style lang="scss" scoped>
$fontFamely: Montserrat, sans-serif;
:root {
    --timeline-modal-info-item-color: #00265c;
    --timeline-modal-info-item-color--active: #00265c;
    --timeline-modal-info-item-bg--active: #edf6ff;
}
.intuit-portal {
    .theme-white {
        --timeline-modal-info-item-color: #00265c;
        --timeline-modal-info-item-color--active: #00265c;
        --timeline-modal-info-item-bg--active: #edf6ff;
    }
    .theme-dark{
        --timeline-modal-info-item-color: #00265c;
        --timeline-modal-info-item-color--active: #00265c;
        --timeline-modal-info-item-bg--active: #edf6ff;
    }
}

.prometheus-portal {
    .theme-white {
        --timeline-modal-info-item-color: #00265c;
        --timeline-modal-info-item-color--active: #00265c;
        --timeline-modal-info-item-bg--active: #edf6ff;
    }
    .theme-dark{
        --timeline-modal-info-item-color: white;
        --timeline-modal-info-item-color--active: #00265c;
        --timeline-modal-info-item-bg--active: #313D56;
    }
}

.timeline-modal-info-item {
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-radius: 18px;
    cursor: pointer;
    padding: 10px 10px;

    &__header {
        display: flex;
        gap: 10px;
        align-items: center;
    }

    &__active {
        background: var(--timeline-modal-info-item-bg--active);
    }
    &__item,
    &__info,
    &__time{
        @include font(12px, normal, 400, none, normal, var(--timeline-modal-info-item-color), $fontFamely);
    }
    &__info {
        padding-left: 35px;
    }
    &__info-item{
        display: flex;
        gap: 5px;
        align-items: flex-end;
        .icon {
            width: 20px;
            height: 20px;
        }
    }
    &__info-item--warn {
        font-weight: 600;
    }
    &__text {
        flex: 1;
        @include font(16px, normal, 500, none, normal, var(--timeline-modal-info-item-color), $fontFamely);
    }
    &__icon {
        $size: 30px;
        width: $size;
        height: $size;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--timeline-modal-info-item-color);
        img {
            width: $size;
            height: $size;
        }
    }
}

</style>